import React, { useState, useEffect } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import { Tabs, Tab } from "@material-ui/core";
import Guide from "./Guide.js";
import ConfirmationMail from "./ConfirmationMail.js";
import update from "immutability-helper";
import { set } from "../../actions";

const AntTabs = withStyles(theme => ({
    root: {
        borderBottom: "1px solid #e8e8e8"
    },
    indicator: {
        backgroundColor: theme.palette.primary.main
    }
}))(Tabs);

const TabPanel = props => (
    <div
        role="tabpanel"
        hidden={props.value !== props.index}
        id={`scrollable-prevent-tabpanel-${props.index}`}
        aria-labelledby={`scrollable-prevent-tab-${props.index}`}
        {...props}>
        {props.value === props.index && <>{props.children}</>}
    </div>
);

const AntTab = withStyles(theme => ({
    root: {
        textTransform: "none",
        minWidth: 72,
        fontWeight: theme.typography.fontWeightRegular,
        marginRight: theme.spacing(4),
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"'
        ].join(","),
        "&:hover": {
            color: theme.palette.primary.main,
            opacity: 1
        },
        "&$selected": {
            color: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium
        },
        "&:focus": {
            color: theme.palette.primary.main
        }
    },
    selected: {}
}))(props => <Tab disableRipple {...props} />);

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1
    }
}));

export default props => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [value, setValue] = useState(0);
    const [bookingMailText, setBookingMailText] = useState("");
    const [bookingMail, setBookingMail] = useState("");
    const therapist = useSelector(state => state.data.therapist);

    useEffect(() => {
        setBookingMailText(therapist.bookingMailText);
        setBookingMail(therapist.bookingMail);
    }, [therapist.bookingMailText, therapist.bookingMail]);

    props.setLocationName();

    return (
        <div className={classes.root}>
            <div>
                <AntTabs value={value} onChange={(event, newValue) => setValue(newValue)} aria-label="ant example">
                    <AntTab label="Guide til opsætning" />
                    <AntTab label="Bekræftelsesmail" />
                </AntTabs>
            </div>
            <TabPanel value={value} index={0}>
                <Guide />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <ConfirmationMail
                    changeBM={setBookingMail}
                    propBM={bookingMail}
                    changeBMT={setBookingMailText}
                    propBMT={bookingMailText}
                    saveBMT={() => {
                        dispatch(
                            set({
                                therapist: update(therapist, {
                                    bookingMailText: { $set: bookingMailText },
                                    bookingMail: { $set: bookingMail }
                                })
                            })
                        );
                        alert("Gemt!");
                    }}
                />
            </TabPanel>
        </div>
    );
};
